import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/faqs';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-line bg-navy py-8 sm:py-12" aria-labelledby="faq-title" data-id="element-16" data-mp="uq9ehrhsud5x">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-17" data-mp="70osezqcmzsf">
        <div id="faq-title" data-id="element-18" data-mp="73aysw1i7992">
          <SectionHeading title="Frequently Asked Questions" data-id="element-19" data-mp="22djcr7votb9" />
        </div>

        <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-20" data-mp="24hv1vc0qwm3">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.question} data-id="element-21" data-mp="1sejiud525d07" data-mpi={i}>
                <h3 data-id="element-22" data-mp="1sdi0ropmjq8z">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-lg font-bold text-cream transition-colors duration-150 ease-out hover:text-pumpkin focus-visible:outline-none focus-visible:text-pumpkin" data-id="element-23" data-mp="1scq7ikji24lv">
                    {faq.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-pumpkin transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-24" data-mp="vre83h1ryjmg" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-25" data-mp="cue6h07cc6zt">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-26" data-mp="cwh2c0v6cucg">
                      <p className="pb-5 pr-8 text-base leading-relaxed text-muted" data-id="element-27" data-mp="iobo4ijotk1a">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}